<div class="world-map-wrapper">
  <h4 class="world-map-title" *ngIf="data?.title" style="font-size: calc(1.25rem * var(--dvm-font-scale, 1));">{{ data.title | capitalCase }}</h4>

  <div class="world-map-inner">
    @if(data?.customPayload?.filter) {
    <div class="world-map-sidebar">
      <app-global-filter [config]="data.customPayload.filter"></app-global-filter>
    </div>
    }

    <div id="{{data.widgetId}}" class="world-map-container" [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'"></div>
  </div>
</div>